import { render, staticRenderFns } from "./CourseDetailVideoPlayPage.vue?vue&type=template&id=52317646&scoped=true"
import script from "./CourseDetailVideoPlayPage.vue?vue&type=script&lang=js"
export * from "./CourseDetailVideoPlayPage.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailVideoPlayPage.vue?vue&type=style&index=0&id=52317646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52317646",
  null
  
)

export default component.exports